import {Component, computed, effect, inject, input, model, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DatePicker} from 'primeng/datepicker';
import {InputTextModule} from 'primeng/inputtext';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {PrimeNG} from 'primeng/config';
import {DatepickerLocaleUtils} from '../../datepicker-locale.util';
import {DirectusTooltipComponent} from '../../../directus-tooltip/directus-tooltip.component';

@Component({
  selector: 'app-model-field-datepicker',
  imports: [
    CommonModule,
    FormsModule,
    DatePicker,
    InputTextModule,
    TranslocoPipe,
    DirectusTooltipComponent,
  ],
  templateUrl: './model-field-datepicker.component.html',
})
export class ModelFieldDatepickerComponent {
  private readonly primeng = inject(PrimeNG);
  private readonly translocoService = inject(TranslocoService);

  id = input.required<string>();
  label = input<string>('');
  placeholder = input<string>('');
  tooltipKey = input<string>('');
  isReadOnly = input<boolean>(false);
  smallLabel = input<boolean>(false);
  isRequired = input<boolean>(false);
  invalid = input<boolean>(false);

  dateFormat = input<string>('dd.mm.yy');
  readOnlyFormat = input<string>('dd.MM.yyyy');

  minDate = input<Date | null>(null);
  maxDate = input<Date | null>(null);

  value = model<Date | null>(null);

  readonly userLanguage = signal<string>(this.translocoService.getActiveLang());

  protected readonly isTouched = signal<boolean>(false);

  protected readonly showInvalid = computed<boolean>(
    () => this.isTouched() && (this.invalid() || (this.isRequired() && this.value() === null)),
  );

  constructor() {
    effect(() => {
      this.primeng.setTranslation(DatepickerLocaleUtils.getLocale(this.userLanguage()));
    });
  }

  protected markAsTouched(): void {
    this.isTouched.set(true);
  }
}
